import { render } from "./WidgetAssignHistory.vue?vue&type=template&id=1cfb9224&scoped=true&ts=true"
import script from "./WidgetAssignHistory.vue?vue&type=script&lang=ts"
export * from "./WidgetAssignHistory.vue?vue&type=script&lang=ts"

import "./WidgetAssignHistory.vue?vue&type=style&index=0&id=1cfb9224&scoped=true&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfb9224"]])

export default __exports__